const addAccordianState = (payload) => ({
  type: "ADD_ACCORDIAN_STATE",
  payload
})


const updateAccordianState = (payload) => ({
    type: "UPDATE_ACCORDIAN_STATE",
    payload
  })

export {
    addAccordianState,
    updateAccordianState,
}